'use client';

import React, { useState } from 'react';
import { useSearchParams } from 'next/navigation';
import Link from 'next/link';

import { PRODUCTS, getProductById } from '@/lib/mockData';
import ProductHeader from './ProductHeader';
import WeightSelector from './WeightSelector';
import PriceComparisonTable from './PriceComparisonTable';
import PriceHistoryChart from './PriceHistoryChart';
import ProductSpecs from './ProductSpecs';
import RelatedProducts from './RelatedProducts';

export default function ProductDetailContent() {
  const searchParams = useSearchParams();
  const id = searchParams?.get('id') || 'prod-rc-medium-adult';

  const product = getProductById(id) || PRODUCTS?.[0];
  const [selectedWeight, setSelectedWeight] = useState(
    product?.availableWeights?.[1] ?? product?.availableWeights?.[0]
  );

  return (
    <div className="max-w-screen-2xl mx-auto px-4 lg:px-8 xl:px-10 2xl:px-16 py-8">
      {/* Breadcrumb */}
      <div className="flex items-center gap-2 mb-6 text-sm text-gray-500">
        <Link href="/home-search" className="hover:text-orange-600 transition-colors">Accueil</Link>
        <span>/</span>
        <Link href="/search-results" className="hover:text-orange-600 transition-colors">Croquettes</Link>
        <span>/</span>
        <span className="text-gray-800 font-medium line-clamp-1">{product?.name}</span>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 xl:grid-cols-4 gap-8">
        {/* Left column — product info */}
        <div className="lg:col-span-1">
          <ProductHeader product={product} selectedWeight={selectedWeight} />
          <div className="mt-4">
            <WeightSelector
              weights={product?.availableWeights}
              selected={selectedWeight}
              onSelect={setSelectedWeight}
              productId={product?.id}
            />
          </div>
          <div className="mt-4">
            <ProductSpecs product={product} />
          </div>
        </div>

        {/* Right column — comparison */}
        <div className="lg:col-span-2 xl:col-span-3">
          <PriceComparisonTable productId={product?.id} weightKg={selectedWeight} />
          <div className="mt-8">
            <PriceHistoryChart productId={product?.id} weightKg={selectedWeight} />
          </div>
        </div>
      </div>
      {/* Related products */}
      <div className="mt-12">
        <RelatedProducts currentProductId={product?.id} dogSizes={product?.dogSizes} />
      </div>
    </div>
  );
}